import request from './clientsApi';
import { API_ROUTES } from '../config/baseURL';

/**
 * Envía un ticket de soporte al Backend.
 * @param {Object} data - Datos provenientes del formulario de soporte (nombre, correo, telefono, mensaje)
 * @returns {Promise<Object>} Promesa que resuelve la data de la respuesta (success, mensaje)
 */
export const sendSupportTicket = async (data) => {
  const res = await request(API_ROUTES.soportePost, {
    method: 'POST',
    body: JSON.stringify(data)
  });
  
  return res.json();
};
